import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Button, Box } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';

const RestrictedTime = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', mt: 8 }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <LockOutlined color="error" sx={{ fontSize: 60 }} />
      </Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Access Restricted
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Access to this system is restricted from 5:00 PM to 8:30 AM for your user role.
        Please try again during allowed hours or contact an administrator.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleGoHome}
        sx={{ mt: 2 }}
      >
        Return to Homepage
      </Button>
      <Typography variant="h4" component="h1" mt={5}>See You At</Typography>
      <Typography variant='h1' fontWeight={700} color='green'>08:30</Typography>
    </Container>
  );
};

export default RestrictedTime;